var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.044572, 1.682155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.95 0.82 C 16.19 0.82 20.439 5.068 20.439 10.309 C 20.439 15.549 16.19 19.797 10.95 19.797 C 5.71 19.797 1.461 15.549 1.461 10.309"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.783ff2f71ca0066e5eaa5774b77a1b56.svg";
export { ForwardRef as ReactComponent };